<ion-header [translucent]="true">
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
    <ion-title>Közösség</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true" *ngIf="user$ && userMetadata && post">


  <ion-card>
    <ion-card-header>
      <ion-card-title>{{post.attributes.title}}</ion-card-title>
      <ion-card-subtitle><span *ngFor="let tag of post.relationships.tags.data">
          <span *ngFor="let inc of included">
            <ion-badge *ngIf="tag.id == inc.id && inc.type=='tags'" color="primary">{{inc.attributes.name}}</ion-badge>
          </span>
        </span></ion-card-subtitle>
    </ion-card-header>
    <ion-card-content>
      <!--ion-list>
      <ion-item *ngFor="let d of discussions">
        <ion-thumbnail slot="start">
          <img alt="Silhouette of mountains" src="https://ionicframework.com/docs/img/demos/thumbnail.svg" />
        </ion-thumbnail>
        <ion-label>{{d.attributes.title}}</ion-label>
      </ion-item>

    </ion-list-->
      <div class="DiscussionList">
        <ul role="feed" class="DiscussionList-discussions">
          <span *ngFor="let inc of included">
            <li data-id="2" role="article" aria-setsize="-1" aria-posinset="1" *ngIf="inc.type=='posts'"
              style="border-bottom: 1px solid;margin-top:5px;padding-bottom: 5px;">
              <div class="DiscussionListItem">
                <div class="DiscussionListItem-content Slidable-content read">
                  <ion-avatar class=" DiscussionListItem-author" style="margin-top: 0">
                    <!--img *ngIf="user$.attributes?.picture" [src]="user$.attributes.picture" [alt]="userMetadata.viselt_ker" /-->
                    <img [src]="environment.avatars+'/api/?name=TESZT&rounded=true&size=50&background=random'">
                  </ion-avatar>
                  <a [routerLink]="['/m/post', post.attributes.slug]" class="DiscussionListItem-main">
                    <h2 class="DiscussionListItem-title"><span *ngFor="let inc2 of included"><span
                          *ngIf="inc2.type=='users' && inc2.id==inc.relationships.user.data.id"> <span
                            class="username" style="font-weight: bold;">{{inc2.attributes.displayName}} - {{moment(inc.attributes.createdAt).format("YYYY.MM.DD. HH:mm:ss")}}</span></span></span></h2>
                    <br><ul class="DiscussionListItem-info">
                      <li class="item-terminalPost"><span [innerHTML]="inc.attributes.contentHtml"></span>
                      </li>
                    </ul>
                  </a><!--span class="DiscussionListItem-count"><span
                    aria-hidden="true">{{post.attributes.commentCount-1}}</span><span class="visually-hidden">0
                    válasz</span></span-->
                </div>
              </div>
            </li>
          </span>
        </ul>
      </div>
    </ion-card-content>
  </ion-card>






</ion-content>